import React from "react";
import logo from "../../assets/images/vole-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const Navbar = ({ onClickMenu }) => {
  return (
    <div className="navbar" id="navbar">
      <div className="navbar-container">
        <div className="logo">
          <div className="menu-icon" onClick={onClickMenu}>
            <FontAwesomeIcon
              icon={faBars}
              style={{ fontSize: "20px" }}
              color={"black"}
            />
            {/* <MenuIcon /> */}
          </div>
          <Link to="/home" style={{ display: "flex", alignItems: "center" }}>
            <img className="logo-img" src={logo} alt="vole" />
          </Link>
        </div>
        {/* <div className="main-items" >
                    <NavLink activeClassName="active-link" to="/home/1" style={{textDecoration: "none"}} ><span>SANA ÖZEL</span></NavLink>
                    <NavLink activeClassName="active-link" to="/home/2" style={{textDecoration: "none"}}><span>VİDEO</span></NavLink>
                    <NavLink activeClassName="active-link" to="/home/3" style={{textDecoration: "none"}}><span>PODCAST</span></NavLink>
                </div> */}

        {/* {isAuth ? (
          <div
            className="searchBar"
            onClick={() => {
             Cookies.remove("token");
            }}
          >
            <div className="middleSide">
              <input
                type="text"
                className="search-bar"
                placeholder="Ara"
                style={{ padding: "10px" }}
              />
              <button className="search-button">
                <img className="search-img" src={Search} />{" "}
              </button>
            </div>
          </div>
        ) : null} */}
      </div>
    </div>
  );
};

export default Navbar;
